import React from 'react';

class GiphyItem extends React.Component {
  constructor(props) {
    super(props);

    this._onLoaded = this._onLoaded.bind(this);
    this.gifPressed = this.gifPressed.bind(this);

    this.state = {
      url: props.placeholder_url,
    };
  }

	gifPressed = (sendGif) => {
	  this.setState({ sendGif });
	  this.props.onGifPress(sendGif);
	};

	_onLoaded() {
	  if (!this.props.onlyStill) {
	    this.setState({ url: this.props.url });
	  }
	}

	render() {
	  return (
  <img
    style={{ cursor: 'pointer' }}
    height={100}
    onLoad={this._onLoaded}
    src={this.state.url}
    onClick={event => this.gifPressed(this.props.send_url)}
  />
	  );
	}
}

module.exports = GiphyItem;
